import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { QuestionJSONAModel } from "interfaces/jsona-models/QuestionJSONAModel";

export class QuestionSelector extends BaseApiSelector<QuestionJSONAModel> {
  constructor() {
    super(ResourceType.Question);
  }
}
